import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useLanguage } from '../../../hooks/useLanguage';

interface InspectionAnalyticsProps {
    data: {
        total: {
            pending: number;
            viewed: number;
            accepted: number;
            completed: number;
            rejected: number;
        };
        rates: {
            conversion: number;
            completion: number;
        };
        timeSeries: Array<{
            date: string;
            created: number;
            viewed: number;
            accepted: number;
            completed: number;
            rejected: number;
        }>;
    };
}

export const InspectionAnalytics: React.FC<InspectionAnalyticsProps> = ({ data }) => {
    const { t, isRTL } = useLanguage();

    // Formater les données pour le graphique avec traductions
    const chartData = data.timeSeries.map(item => ({
        date: new Date(item.date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' }),
        [t('analytics.chart.viewed')]: item.viewed,
        [t('analytics.chart.rejected')]: item.rejected,
        [t('analytics.chart.completed')]: item.completed
    }));

    return (
        <div className="bg-white rounded-lg shadow p-6" dir={isRTL ? 'rtl' : 'ltr'}>
            <h3 className={`text-xl font-bold mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                {t('analytics.inspectionStats.title')}
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    <h4 className="text-sm text-gray-500">{t('analytics.inspectionStats.pending')}</h4>
                    <p className="text-2xl font-bold">{data.total.pending}</p>
                </div>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    <h4 className="text-sm text-gray-500">{t('analytics.inspectionStats.viewed')}</h4>
                    <p className="text-2xl font-bold">{data.total.viewed}</p>
                </div>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    <h4 className="text-sm text-gray-500">{t('analytics.inspectionStats.rejected')}</h4>
                    <p className="text-2xl font-bold">{data.total.rejected}</p>
                </div>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    <h4 className="text-sm text-gray-500">{t('analytics.inspectionStats.completed')}</h4>
                    <p className="text-2xl font-bold">{data.total.completed}</p>
                </div>
            </div>

            <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey={t('analytics.chart.viewed')} fill="#94a3b8" />
                        <Bar dataKey={t('analytics.chart.rejected')} fill="#ef4444" />
                        <Bar dataKey={t('analytics.chart.completed')} fill="#4ade80" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* <div className="grid grid-cols-2 gap-4 mt-6">
                <div className="bg-blue-50 p-4 rounded-lg" dir={isRTL ? 'rtl' : 'ltr'}>
                    <h4 className={`text-sm text-blue-800 font-medium ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('analytics.rates.conversion.title')}
                    </h4>
                    <p className="text-2xl font-bold text-blue-600">{data.rates.conversion.toFixed(1)}%</p>
                    <p className={`text-xs text-blue-700 mt-1 ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('analytics.rates.conversion.description')}
                    </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg" dir={isRTL ? 'rtl' : 'ltr'}>
                    <h4 className={`text-sm text-green-800 font-medium ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('analytics.rates.completion.title')}
                    </h4>
                    <p className="text-2xl font-bold text-green-600">{data.rates.completion.toFixed(1)}%</p>
                    <p className={`text-xs text-green-700 mt-1 ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('analytics.rates.completion.description')}
                    </p>
                </div>
            </div> */}
        </div>
    );
};